<template>
    <div class="px-10 w-5/6">
        <div class="flex gap-5 py-10 flex-col">
            <div class="w-full gap-5 flex">
                <input
                    type="text"
                    class="w-full px-5 py-2 rounded border"
                    placeholder="Enter keyword"
                    v-model="keyword"
                >
                <button
                    type="button"
                    class="px-5 py-3 bg-peach text-white rounded"
                    @click="fetchCodes"
                >
                    Search
                </button>
            </div>

            <div class="flex gap-5 justify-end w-full">
                <div
                    v-if="AUTH_USER.data.is_tourism === 1"
                    class="w-1/3"
                >
                    <select
                        v-model="partnerID"
                        class="px-5 py-2 rounded border w-full"
                        @change="onSelectPartner($event)"
                    >
                        <option value selected>None</option>
                        <option
                            v-if="partners.length"
                            v-for="(partner, index) in partners"
                            :key="index"
                            :value="partner.company.id"
                        >
                            {{ partner.company.name }}
                        </option>
                    </select>
                </div>
                <div class="w-1/3">
                    <input
                        type="number"
                        class="px-5 py-2 rounded border w-full"
                        placeholder="Number of Codes"
                        v-model="maxCodes"
                    >
                </div>
                <div class="w-1/3">
                    <button
                        type="button"
                        class="bg-peach px-5 rounded text-sm text-white w-full h-full"
                        :class="{ 'cursor-not-allowed opacity-75' : !maxCodes }"
                        :disabled="!maxCodes"
                        @click="generateCodes"
                    >
                        Generate Codes
                    </button>
                </div>
            </div>
        </div>

        <div
            v-if="AUTH_USER.data.is_tourism === 0"
            class="bg-peach flex font-medium items-center p-5 rounded-t-lg text-white"
        >
            <div class="w-1/6">Code</div>
            <div class="w-1/6">Status</div>
            <div class="w-1/6">Used</div>
            <div class="w-1/6">Name</div>
            <div class="w-1/6">generiert am</div>
            <div class="w-1/6 text-center">Action</div>
        </div>
        <div
            v-else
            class="bg-peach flex font-medium items-center p-5 rounded-t-lg text-white"
        >
            <div class="w-2/12">Code</div>
            <div class="w-1/12">Status</div>
            <div class="w-1/12">Used</div>
            <div class="w-2/12">Name</div>
            <div class="w-2/12">Company</div>
            <div class="w-2/12">generiert am</div>
            <div class="w-2/12 text-center">Action</div>
        </div>

        <template v-if="codes.total !== 0">
            <template v-if="AUTH_USER.data.is_tourism === 0">
                <div
                    v-for="(code, index) in codes.data"
                    class="flex gap-5 items-center p-5 text-sm"
                    :class="{ 'bg-white' : !(index % 2), 'bg-gray-100' : index % 2, 'rounded-b-lg' : index == codes.data.length - 1 }"
                    :key="code.id"
                >
                    <div class="font-bold text-peach w-1/6 tracking-widest">{{ code.value }}</div>
                    <div class="w-1/6">
                        <span
                            class="text-white text-xs px-3 py-1 rounded-full"
                            :class="{ 'bg-red-600' : !code.is_active, 'bg-green-600' : code.is_active }"
                        >
                            {{ code.is_active ? 'Active' : 'Inactive' }}
                        </span>
                    </div>
                    <div class="font-bold w-1/6">
                        {{ code.redemptions.length ? 'Yes' : 'No' }}
                    </div>
                    <div class="w-1/6">{{ code.user_details ? `${code.user_details.firstName} ${code.user_details.lastName}` : ''}}</div>
                    <div class="w-1/6">{{ code.created_at }}</div>
                    <div class="w-1/6 flex flex-col gap-3">
                        <button
                            v-if="code.user"
                            class="py-2 rounded text-sm text-white w-full"
                            :class="{ 'bg-red-600' : code.is_active, 'bg-green-600' : !code.is_active }"
                            @click="toggleStatus(code.id, code.is_active)"
                        >
                            {{ code.is_active ? 'Deactivate' : 'Activate' }}
                        </button>

                        <button
                            class="py-2 rounded text-sm text-white w-full bg-black"
                            @click="onDownloadPDF(code.value)"
                            type="button"
                        >
                            Download PDF
                        </button>
                    </div>
                </div>
            </template>

            <template v-else>
                <div
                    v-for="(code, index) in codes.data"
                    class="flex gap-5 items-center p-5 text-sm"
                    :class="{ 'bg-white' : !(index % 2), 'bg-gray-100' : index % 2, 'rounded-b-lg' : index == codes.data.length - 1 }"
                    :key="code.id"
                >
                    <div class="font-bold text-peach w-2/12 tracking-widest">{{ code.value }}</div>
                    <div class="w-1/12">
                        <span
                            class="text-white text-xs px-3 py-1 rounded-full"
                            :class="{ 'bg-red-600' : !code.is_active, 'bg-green-600' : code.is_active }"
                        >
                            {{ code.is_active ? 'Active' : 'Inactive' }}
                        </span>
                    </div>
                    <div class="font-bold w-1/12">
                        {{ code.redemptions.length ? 'Yes' : 'No' }}
                    </div>
                    <div class="w-2/12">{{ code.user_details ? `${code.user_details.firstName} ${code.user_details.lastName}` : ''}}</div>
                    <div class="w-2/12">{{ code.company ? code.company.name : ''}}</div>
                    <div class="w-2/12">{{ code.created_at }}</div>
                    <div class="w-2/12 flex flex-col gap-3">
                        <button
                            v-if="code.user"
                            class="py-2 rounded text-sm text-white w-full"
                            :class="{ 'bg-red-600' : code.is_active, 'bg-green-600' : !code.is_active }"
                            @click="toggleStatus(code.id, code.is_active)"
                        >
                            {{ code.is_active ? 'Deactivate' : 'Activate' }}
                        </button>

                        <button
                            class="py-2 rounded text-sm text-white w-full bg-black"
                            @click="onDownloadPDF(code.value)"
                            type="button"
                        >
                            Download PDF
                        </button>
                    </div>
                </div>
            </template>
        </template>

        <template v-else>
            <div class="text-center text-2xl mt-3">
                No data found.
            </div>
        </template>

        <template v-if="codes.total !== 0">
            <TailwindPagination
                :data="codes"
                :limit="3"
                @pagination-change-page="fetchCodes"
            />
        </template>
    </div>
</template>

<script>
    import TailwindPagination from 'laravel-vue-pagination'

    export default {
        components: {
            TailwindPagination
        },
        data() {
            return {
                codes: [],
                limit: 10,
                maxCodes: 0,
                page: 1,
                keyword: '',
                partnerID: '',
                partners: []
            }
        },
        computed: {
            AUTH_USER() {
                return this.$store.getters.AUTH_USER;
            },
        },
        mounted() {
            this.fetchCodes()
            this.fetchActivePartners()
        },
        methods: {
            async fetchCodes(page = undefined) {
                try {
                    await this.$store.commit('SET_CODES', [])
                    await this.$store.commit('SET_IS_LOADING', { status: 'open' })

                    const { codes } = await this.$store.dispatch('FETCH_CODES', {
                        pagination: this.limit,
                        page: page ?? this.page,
                        keyword: this.keyword,
                        partnerID: this.partnerID
                    })

                    this.codes = codes

                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                } catch(error) {
                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                }
            },
            async generateCodes() {
                try {
                    await this.$store.commit('SET_IS_LOADING', { status: 'open' })

                    const data = await this.$store.dispatch(
                        'GENERATE_CODES',
                        {
                            max: this.maxCodes,
                            partnerID: this.partnerID
                        }
                    )

                    this.maxCodes = 0
                    this.page = 1
                    this.keyword = ''
                    this.partnerID = ''
                    this.fetchCodes()

                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                } catch(error) {
                    console.log('error', error)

                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                }
            },
            async toggleStatus(id, status) {
                try {

                    const data = await this.$store.dispatch(
                        'TOGGLE_CODE_STATUS',
                        {
                            id: id,
                            status: status ? 'inactive' : 'active'
                        }
                    )

                    this.maxCodes = 0
                    this.page = 1
                    this.keyword = ''
                    this.fetchCodes()

                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                } catch(error) {
                    console.log('error', error)

                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                }
            },
            async onDownloadPDF(code) {
                try {
                    await this.$store.commit('SET_IS_LOADING', { status: 'open' })

                    const data = await this.$store.dispatch(
                        'DOWNLOAD_CODE_PDF',
                        {
                            code: code
                        }
                    )

                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                } catch(error) {
                    console.log('error', error)

                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                }
            },
            async fetchActivePartners() {
                try {
                    await this.$store.commit('SET_CODES', [])
                    await this.$store.commit('SET_IS_LOADING', { status: 'open' })

                    const { partners } = await this.$store.dispatch('FETCH_ACTIVE_PARTNERS')

                    this.partners = partners

                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                } catch(error) {
                    await this.$store.commit('SET_IS_LOADING', { status: 'close' })
                }
            },
            onSelectPartner(event) {
                this.partnerID = event.target.value

                this.fetchCodes()
            }
        },
    }
</script>

<style>
    ul.pagination {
        display: flex;
        gap: 20px;
        justify-content: center;
        margin-top: 20px; 
    }
</style>